import { render } from "./unauthorized.vue?vue&type=template&id=1f467dfd&scoped=true"
import script from "./unauthorized.vue?vue&type=script&lang=js"
export * from "./unauthorized.vue?vue&type=script&lang=js"

import "./unauthorized.vue?vue&type=style&index=0&id=1f467dfd&lang=scss&scoped=true"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f467dfd"]])

export default __exports__